<div class="lessons-tab-container">
  <!-- Loading State -->
  <ng-container *ngIf="apiLessonsLoading">
    <div style="text-align: center; padding: 40px;">
      <img src="assets/images/spinner.png" alt="Loading..." class="spinner-icon" style="width: 40px; height: 40px;" />
      <p style="margin-top: 16px; color: #666;">Loading...</p>
    </div>
  </ng-container>

  <!-- Error State -->
  <ng-container *ngIf="apiLessonsError && !apiLessonsLoading">
    <div style="text-align: center; padding: 40px;">
      <p style="color: #d32f2f; font-weight: 500;">{{ apiLessonsError }}</p>
    </div>
  </ng-container>

  <!-- API Data Display (Lookback Lessons Report) -->
  <ng-container *ngIf="!apiLessonsLoading && !apiLessonsError && parsedLessons.length > 0">
    <div class="lookback-lessons-container">
      
      

      <!-- Single Well View -->
      <ng-container *ngIf="!isMultiWellMode">
        <div *ngFor="let lesson of parsedLessons" class="single-well-lessons">
          <!-- AI Generated Badge for single well -->
          <div class="single-well-header">
            <span class="ai-badge">
              <img src="assets/images/ai_sparkle.png" alt="AI" class="icon-image-natural" />
              AI Generated
            </span>
          </div>
          
          <!-- Full markdown content for single well (always show full) -->
          <div class="markdown-content" style="margin-top: -0.83em;">
            <div [innerHTML]="lesson.markdownHtml"></div>
          </div>
        </div>
      </ng-container>

      <!-- Multi-Well View -->
      <ng-container *ngIf="isMultiWellMode">
        <div *ngFor="let lesson of parsedLessons" class="multi-well-lessons">
          <!-- Well Name Header -->
          <div class="well-name-header">
            <div class="header-left">
              <h3>{{ lesson.wellName }}</h3>
              <span class="ai-badge">
                <img src="assets/images/ai_sparkle.png" alt="AI" class="icon-image-natural" />
                AI Generated
              </span>
            </div>
          </div>

          <!-- Preview Content (truncated with Show More button) -->
          <div class="well-preview-content" *ngIf="!lesson.fullContentExpanded">
            <div class="markdown-content markdown-preview">
              <div [innerHTML]="getTruncatedMarkdown(lesson)"></div>
            </div>
            
            <div class="show-more-button-container">
              <button 
                class="show-more-btn" 
                (click)="toggleFullContent(lesson, $event)">
                Show More
              </button>
            </div>
          </div>

          <!-- Full Content (when Show More is clicked) -->
          <div class="well-full-content" *ngIf="lesson.fullContentExpanded">
            <div class="markdown-content">
              <div [innerHTML]="lesson.markdownHtml"></div>
            </div>
            
            <div class="show-more-button-container">
              <button 
                class="show-more-btn expanded"
                (click)="toggleFullContent(lesson, $event)">
                Show Less
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <!-- Fallback: Single Well Lessons (for local/hardcoded data) -->
  <ng-container *ngIf="!isMultiWellMode && !apiLessonsReport && LESSONS && LESSONS.length > 0 && parsedLessons.length === 0">
    <div class="single-well-lessons">
      <div class="lessons-header">
        <div class="header-content">
          <h2>Lessons Learned</h2>
          <span class="ai-badge">
            <img src="assets/images/ai_sparkle.png" alt="AI" class="icon-image-natural" />
            AI Generated
          </span>
        </div>
      </div>
      <div class="lessons-table">
        <table>
          <tbody>
            <tr *ngFor="let row of LESSONS">
              <td>{{ row.insight }}</td>
            </tr>
            <tr *ngIf="LESSONS.length === 0">
              <td style="text-align: center;">No lessons recorded.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>

  <!-- Fallback: Multi-Well Lessons (for local/hardcoded data) -->
  <ng-container *ngIf="isMultiWellMode && !apiLessonsReport && multiWellLessonsByWell && multiWellLessonsByWell.length > 0 && parsedLessons.length === 0">
    <div class="multi-well-lessons-container">
      <div *ngFor="let wellLessons of multiWellLessonsByWell" class="multi-well-lessons">
        <div class="well-header">
          <div class="header-left">
            <h3>{{ wellLessons.wellName }}</h3>
            <span class="ai-badge">
              <img src="assets/images/ai_sparkle.png" alt="AI" class="icon-image-natural" />
              AI Generated
            </span>
          </div>
          <span class="lesson-count">{{ wellLessons.lessons.length }} lesson(s)</span>
        </div>
        <div class="lessons-table">
          <table>
            <tbody>
              <tr *ngFor="let lesson of wellLessons.lessons; let i = index">
                <td>{{ lesson.insight }}</td>
              </tr>
              <tr *ngIf="wellLessons.lessons.length === 0">
                <td style="text-align: center;">No lessons for this well.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="multiWellLessonsByWell.length === 0" style="text-align: center; font-size: 12px; color: #9ca3af; padding: 32px 0;">
        No lessons recorded for selected wells.
      </div>
    </div>
  </ng-container>

  <!-- Empty State (no data at all) -->
  <ng-container *ngIf="!apiLessonsLoading && !apiLessonsError && parsedLessons.length === 0 && (!LESSONS || LESSONS.length === 0) && (!multiWellLessonsByWell || multiWellLessonsByWell.length === 0)">
    <div style="text-align: center; padding: 40px; color: #999;">
      <p>No lessons data available. Please try again or select different wells.</p>
    </div>
  </ng-container>
</div>
